export function createDatadogIdentityLoadGate() {
  let epoch = 0;

  return {
    begin(): number {
      epoch += 1;
      return epoch;
    },
    invalidate(): void {
      epoch += 1;
    },
    isCurrent(token: number): boolean {
      return token === epoch;
    },
  };
}
